'use strict';
const defaults = {
	API_VIMEO: 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/',
	idPlayer: '#player',
	vignettesVideo: '.js-player',
	activeClass: 'is-active',
	selector : {
		container: '.lightbox--video',
		titre: '.video__titre',
		description: '.video__description'
	}
};

module.exports = class video {
	constructor(config) {
		this.config = {...defaults, ...config};
	}
	/**
	 * initialize
	 * @description On récupère les datas de la vidéo et on la stocke côté client
	 * @param id représente l'id de la vidéo de Vimeo
	 * Todo ajouter timestamp au localstorage et faire un check à J + X jours
	 */
	initialize(id, callback) {
		let settings = this.config,
				url = settings.API_VIMEO + id;

		if (localStorage.getItem(`video-${id}`) === null) {
			this._getVimeoJson(url)
			.then((data) => {
				callback != undefined && callback(data, id)
				document.querySelectorAll(`img[data-video-id="${id}"]`).forEach(el => {
					el.src = data.thumbnail_url
				});
				let infosVideo = JSON.stringify(data);
				localStorage.setItem(`video-${id}`, infosVideo);
			})
			.catch(e => console.warn(e));
		} else {
			let data = JSON.parse(localStorage.getItem(`video-${id}`));
			document.querySelectorAll(`img[data-video-id="${id}"]`).forEach(el => el.src = data.thumbnail_url);
			callback != undefined && callback(data, id)
		}

	}

	/**
	 * thumbnailsVideo
	 *
	 * @description Au click sur une des vignettes, on récupère les infos de la vidéo et on la lance
	*/
	thumbnailsVideo(player) {
		let settings = this.config,
				self = this,
				thumbnails = document.querySelectorAll(settings.vignettesVideo);

		for (var i = 0; i < thumbnails.length; i++) {
			thumbnails[i].addEventListener('click', function (e) {
				let id = this.dataset.videoId;
				thumbnails.forEach(el => el.classList.remove(settings.activeClass));
				this.classList.add(settings.activeClass);

				/// On met à jour le player
				player.source = {
					type: 'video',
					sources: [{
						src: id,
						provider: 'vimeo'
					}]
				};

				/// On récupère les datas vimeo depuis le localStorage
				document.querySelector(`${settings.selector.container} ${settings.selector.titre}`).innerHTML = self._getDataVideoFromLocalStorage(id).title;
				document.querySelector(`${settings.selector.container} ${settings.selector.description}`).innerHTML = self._getDataVideoFromLocalStorage(id).description;
			})
		}
	}

	/**
	 * playerVideo
	 *
	 * @description On lance le player vidéo
	*/
	playerVideo() {
		return new Plyr(this.config.idPlayer, {
			captions: {
				active: true
			},
			vimeo: {
				byline: false,
				portrait: false,
				title: true,
				speed: true,
				transparent: false
			}
		});
	}

	/**
	 	* _getVimeoJson
		*
		* @description Au fetch, on renvoie directement la valeur de la promesse
		* @param url l'url de la requête
	*/
	_getVimeoJson(url) {
		return new Promise(async function (resolve, reject) {
			await fetch(url)
			.then((res) => resolve(res.json()))
			.catch((e) => {throw new Error(`Impossible de récupérer les données de Vimeo.\n${e}`)})
		})
	}
	/**
	 	* _getDataVideoFromLocalStorage
		*
		* @description On renvoie le json des infos de la vidéo
		* @param id Identifiant de la vidéo vimeo
	*/
	_getDataVideoFromLocalStorage(id) {
		return JSON.parse(localStorage.getItem(`video-${id}`));
	}
}
